// src/components/login/GoogleLoginButton.tsx
import React, { useEffect, useRef } from 'react';
import { loginWithGoogleClean } from '../../../state/modules/login/actions';
import { useDispatch, useSelector } from 'react-redux';
import { useToast } from '@chakra-ui/react';
import { State } from '../../../state/types';

interface GoogleLoginButtonProps {
  onLogin: (idToken: string) => void;
}

declare global {
  interface Window {
    google?: any;
  }
}

const GoogleLoginButton: React.FC<GoogleLoginButtonProps> = ({ onLogin }) => {
  const buttonDiv = useRef<HTMLDivElement>(null);
  const dispatch = useDispatch();
  const toast = useToast();

  //const { loadingGoogleLogin, loginGoogleSuccess } = useSelector((state: State) => state.googleLogin);

  useEffect(() => {
    if (window.google && buttonDiv.current) {
      window.google.accounts.id.initialize({
        // eslint-disable-next-line camelcase
        client_id: window._env_.REACT_APP_GOOGLE_CLIENT_ID,
        callback: (response: any) => {
          // Aquí recibes el id_token
          onLogin(response.credential);
        },
        // eslint-disable-next-line camelcase
        auto_select: true, // Habilita el auto sign-in
      });

      window.google.accounts.id.renderButton(buttonDiv.current, {
        theme: 'outline',
        size: 'large',
        text: 'signin_with',
        shape: 'rectangular',
        width: 250,
      });

      // Muestra One Tap automáticamente
      window.google.accounts.id.prompt();
    }
  }, [onLogin]);

/*   useEffect(() => {
    if (loginGoogleSuccess === false && !loadingGoogleLogin) {
      toast({
        title: 'Error de autenticación',
        description:
          'El usuario ingresado no existe en EDUprivada. Por favor, revisá los datos o registrate si aún no tenés una cuenta. ¡Gracias!',
        status: 'error',
        duration: 2000,
        isClosable: true,
      })
    }

    dispatch(loginWithGoogleClean())
  }, [loginGoogleSuccess, loadingGoogleLogin, toast]) */

  return <div ref={buttonDiv} style={{ marginLeft: '25px' }} id='g_id_signin'></div>;
};

export default GoogleLoginButton;
